// DUDE TALLOW — theme.js

// ---- VIDEO AUTOPLAY ----
function playVideo(v) {
  v.muted = true;
  v.setAttribute('muted', '');
  v.setAttribute('playsinline', '');
  var p = v.play();
  if (p !== undefined) {
    p.catch(function() {
      document.addEventListener('touchstart', function t() {
        v.play().catch(function(){});
        document.removeEventListener('touchstart', t);
      }, { once: true });
    });
  }
}
// Only load/play videos that are actually visible, and only when scrolled near them
function initVideos() {
  var vids = Array.prototype.slice.call(document.querySelectorAll('video[data-autoplay], video[autoplay]'))
    .filter(function(v) { return v.offsetParent !== null; });
  if (!('IntersectionObserver' in window)) { vids.forEach(playVideo); return; }
  var vo = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) { playVideo(entry.target); vo.unobserve(entry.target); }
    });
  }, { rootMargin: '300px 0px' });
  vids.forEach(function(v) { vo.observe(v); });
}

// ---- RESET BODY SCROLL ON NAVIGATION ----
document.addEventListener('click', function(e) {
  var link = e.target.closest('a[href]');
  if (link && !link.href.includes('#') && link.target !== '_blank') {
    document.body.style.overflow = '';
  }
});
window.addEventListener('pageshow', function() {
  document.body.style.overflow = '';
  document.body.style.opacity = '1';
});
window.addEventListener('popstate', function() {
  document.body.style.overflow = '';
});

// ---- VIDEO SOUND TOGGLE ----
window.toggleSound = function(videoId, btnId) {
  var video = document.getElementById(videoId);
  var btn = document.getElementById(btnId);
  if (!video || !btn) return;
  var otherId = videoId === 'vid1' ? 'vid2' : 'vid1';
  var otherBtnId = videoId === 'vid1' ? 'vid2-sound' : 'vid1-sound';
  var other = document.getElementById(otherId);
  var otherBtn = document.getElementById(otherBtnId);
  if (video.muted) {
    if (other && !other.muted) { other.muted = true; if (otherBtn) otherBtn.textContent = '🔇 Tap for Sound'; }
    video.muted = false;
    btn.textContent = '🔊 Sound On';
  } else {
    video.muted = true;
    btn.textContent = '🔇 Tap for Sound';
  }
};

// ---- MAIN INIT ----
document.addEventListener('DOMContentLoaded', function() {

  initVideos();

  // ---- CART DRAWER ----
  var cartDrawer = document.getElementById('cart-drawer');
  var cartOverlay = document.getElementById('cart-overlay');
  var cartTrigger = document.getElementById('cart-trigger');
  var cartClose = document.getElementById('cart-close');

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function(c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderCartItems(cart) {
    var wrap = document.getElementById('cart-items');
    if (!wrap) return;
    if (!cart || !cart.items || cart.item_count === 0) {
      wrap.innerHTML = '<p style="text-align:center;padding:3rem 1rem;font-size:13px;color:rgba(255,255,255,0.5);">Your cart is empty.<br><a href="/collections/all" style="color:var(--frontier);">Shop now →</a></p>';
      return;
    }
    wrap.innerHTML = cart.items.map(function(item) {
      var key = esc(item.key);
      var img = item.image ? '<img src="' + esc(item.image) + '" alt="' + esc(item.product_title) + '" style="width:100%;height:100%;object-fit:cover;">' : '';
      var variant = (item.variant_title && item.variant_title !== 'Default Title') ? '<div class="cart-item-variant">' + esc(item.variant_title) + '</div>' : '';
      var spa = item.selling_plan_allocation;
      var planVal = spa && spa.selling_plan && spa.selling_plan.options && spa.selling_plan.options[0] ? spa.selling_plan.options[0].value : null;
      var plan = spa ? '<div class="cart-item-plan">&#8635; ' + esc(planVal ? 'Delivers every ' + planVal : spa.selling_plan.name) + '</div>' : '';
      return '<div class="cart-item" data-key="' + key + '">'
        + '<div class="cart-item-img">' + img + '</div>'
        + '<div style="flex:1;min-width:0;">'
        + '<div class="cart-item-name">' + esc(item.product_title) + '</div>'
        + variant
        + plan
        + '<div class="cart-item-price">$' + (item.final_line_price / 100).toFixed(2) + '</div>'
        + '<div class="cart-item-controls">'
        + '<button class="cart-qty-btn" data-key="' + key + '" data-action="minus" aria-label="Decrease quantity">−</button>'
        + '<span class="cart-qty-val">' + item.quantity + '</span>'
        + '<button class="cart-qty-btn" data-key="' + key + '" data-action="plus" aria-label="Increase quantity">+</button>'
        + '<button class="cart-remove-btn" data-key="' + key + '" aria-label="Remove ' + esc(item.product_title) + '">Remove</button>'
        + '</div></div></div>';
    }).join('');
  }

  function applyCart(cart) {
    var c = document.getElementById('cart-count');
    if (c) c.textContent = cart.item_count;
    renderCartItems(cart);
    var s = document.querySelector('.cart-subtotal-row .price');
    if (s) s.textContent = '$' + (cart.total_price / 100).toFixed(2);
    return cart;
  }

  function refreshCart() {
    return fetch('/cart.js').then(function(r) { return r.json(); }).then(applyCart).catch(function() {});
  }

  var lastFocus = null;
  function openCart() {
    if (!cartDrawer) return;
    lastFocus = document.activeElement;
    cartDrawer.classList.add('open');
    cartDrawer.removeAttribute('inert');
    if (cartOverlay) cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    refreshCart();
    if (cartClose) setTimeout(function() { cartClose.focus(); }, 50);
  }

  function closeCart() {
    if (!cartDrawer || !cartDrawer.classList.contains('open')) return;
    cartDrawer.classList.remove('open');
    cartDrawer.setAttribute('inert', '');
    if (cartOverlay) cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  if (cartDrawer && !cartDrawer.classList.contains('open')) cartDrawer.setAttribute('inert', '');

  // Shows Shopify's error (e.g. "sold out") under the button instead of a fake "Added!"
  function showAtcError(btn, msg) {
    if (!btn) return;
    var holder = btn.parentNode;
    var el = holder.querySelector('.atc-error');
    if (!el) { el = document.createElement('p'); el.className = 'atc-error'; el.setAttribute('role', 'alert'); btn.insertAdjacentElement('afterend', el); }
    el.textContent = msg || 'Sorry, we couldn\'t add that to your cart. Please try again.';
    setTimeout(function() { if (el && el.parentNode) el.parentNode.removeChild(el); }, 6000);
  }

  function postAdd(fetchOpts, btn, btnText) {
    var label = btnText || 'Add to Cart';
    if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }
    return fetch('/cart/add.js', fetchOpts)
      .then(function(r) { return r.json().then(function(j) { return { ok: r.ok, json: j }; }); })
      .then(function(res) {
        if (btn) btn.disabled = false;
        if (!res.ok) {
          if (btn) btn.textContent = label;
          showAtcError(btn, res.json && (res.json.description || res.json.message));
          return;
        }
        if (btn) { btn.textContent = 'Added!'; setTimeout(function() { btn.textContent = label; }, 2000); }
        openCart();
      })
      .catch(function() { if (btn) { btn.disabled = false; btn.textContent = label; } showAtcError(btn); });
  }

  function addToCart(id, qty, btn, btnText) {
    if (!id) return;
    return postAdd({
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    }, btn, btnText);
  }

  var cartBusy = false;
  function updateCartLine(key, qty) {
    if (cartBusy || !key) return;
    cartBusy = true;
    var wrap = document.getElementById('cart-items');
    if (wrap) wrap.style.opacity = '0.6';
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function(r) { if (!r.ok) throw new Error('change failed'); return r.json(); })
      .then(applyCart)
      .catch(function() { return refreshCart(); })
      .then(function() { cartBusy = false; if (wrap) wrap.style.opacity = ''; });
  }

  if (cartTrigger) cartTrigger.addEventListener('click', function(e) { e.preventDefault(); openCart(); });
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeCart(); });

  // Delegated click for cart qty/remove
  document.addEventListener('click', function(e) {
    var qb = e.target.closest('.cart-qty-btn');
    if (qb) {
      if (cartBusy) return;
      var controls = qb.closest('.cart-item-controls');
      var valEl = controls ? controls.querySelector('.cart-qty-val') : null;
      if (!valEl) return;
      var cur = parseInt(valEl.textContent) || 1;
      var nq = qb.dataset.action === 'plus' ? cur + 1 : Math.max(0, cur - 1);
      valEl.textContent = nq;
      updateCartLine(qb.dataset.key, nq);
      return;
    }
    var rb = e.target.closest('.cart-remove-btn');
    if (rb) { updateCartLine(rb.dataset.key, 0); return; }
  });

  // ---- ATC FORMS — intercept ALL homepage forms ----
  function bindForm(formId, qtyId, btnLabel) {
    var form = document.getElementById(formId);
    if (!form) return;
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      if (btn && btn.disabled) return;
      // Subscription selected (Seal) — send the whole form so selling_plan goes with it
      var sealInput = form.querySelector('input[name="selling_plan"]');
      if (sealInput && sealInput.value) {
        postAdd({ method: 'POST', body: new FormData(form) }, btn, btnLabel);
        return;
      }
      e.stopImmediatePropagation();
      var idInput = form.querySelector('input[name="id"]');
      var qtyEl = document.getElementById(qtyId);
      if (!idInput || !idInput.value) return;
      addToCart(idInput.value, parseInt(qtyEl ? qtyEl.value : 1) || 1, btn, btnLabel);
    });
  }

  bindForm('hero-form',  'hero-qty',  'ADD TO CART');
  bindForm('cbd-form',   'cbd-qty',   'Add to Cart');
  bindForm('combo-form', 'combo-qty', 'Add to Cart');
  bindForm('product-form',    'fp-qty',    'Add to Cart');

  // Product card ATC buttons
  document.querySelectorAll('[data-add-to-cart]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var form = this.closest('form');
      if (!form) return;
      var id = form.querySelector('[name="id"]') ? form.querySelector('[name="id"]').value : null;
      addToCart(id, 1, btn, 'Add to Cart');
    });
  });

  // Buy now
  var buyBtn = document.getElementById('fp-buy-btn');
  if (buyBtn) buyBtn.addEventListener('click', function() {
    var idEl = document.getElementById('fp-variant-id');
    if (!idEl || !idEl.value || buyBtn.disabled) return;
    var pf = document.getElementById('product-form');
    var qtyEl = document.getElementById('fp-qty');
    var qty = parseInt(qtyEl ? qtyEl.value : 1) || 1;
    var spEl = pf ? pf.querySelector('input[name="selling_plan"]') : null;
    var sp = spEl && spEl.value ? spEl.value : null;
    if (!sp) { window.location.href = '/cart/' + idEl.value + ':' + qty; return; }
    // Subscription selected: add with the chosen plan, then go straight to checkout
    buyBtn.textContent = 'Loading...';
    var item = { id: parseInt(idEl.value), quantity: qty, selling_plan: parseInt(sp) };
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [item] }) })
      .then(function(r) { return r.json().then(function(j) { if (!r.ok) throw new Error(j.description || j.message || ''); return j; }); })
      .then(function() { window.location.href = '/checkout'; })
      .catch(function(err) { buyBtn.textContent = 'Buy It Now'; showAtcError(buyBtn, err && err.message); });
  });

  // ---- QTY CONTROLS ----
  [
    ['fp-qty-minus',    'fp-qty'],
    ['fp-qty-plus',     'fp-qty'],
    ['hero-qty-minus',  'hero-qty'],
    ['hero-qty-plus',   'hero-qty'],
  ].forEach(function(pair) {
    var btn = document.getElementById(pair[0]);
    var inp = document.getElementById(pair[1]);
    if (btn && inp) {
      btn.addEventListener('click', function() {
        var v = parseInt(inp.value) || 1;
        inp.value = pair[0].includes('minus') ? Math.max(1, v - 1) : v + 1;
      });
    }
  });

  // ---- MOBILE NAV ----
  var navToggle = document.getElementById('nav-toggle');
  var mainNav = document.getElementById('main-nav');
  if (navToggle && mainNav) {
    navToggle.addEventListener('click', function(e) {
      e.stopPropagation();
      var open = mainNav.classList.toggle('nav-open');
      this.setAttribute('aria-expanded', String(open));
    });
    document.addEventListener('click', function(e) {
      if (mainNav.classList.contains('nav-open') && !navToggle.contains(e.target) && !mainNav.contains(e.target)) {
        mainNav.classList.remove('nav-open');
        navToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  // ---- TABS ----
  document.querySelectorAll('.fp-tab-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var section = this.closest('.fp-tabs');
      if (section) {
        section.querySelectorAll('.fp-tab-btn').forEach(function(b) { b.classList.remove('active'); });
        section.querySelectorAll('.fp-tab-content').forEach(function(c) { c.classList.remove('active'); });
      }
      this.classList.add('active');
      var tab = document.getElementById('tab-' + this.dataset.tab);
      if (tab) tab.classList.add('active');
    });
  });

  // ---- VARIANT SELECTOR ----
  var variantData = document.getElementById('product-variants-json');
  // Only run for products that actually have option buttons (sizes etc.) — single-variant products skip this entirely
  if (variantData && document.querySelector('.fp-variant-btn')) {
    var variants = JSON.parse(variantData.textContent);
    var selectedOptions = {};

    // Initialize selected options from active buttons
    document.querySelectorAll('.fp-variant-btn.active').forEach(function(btn) {
      selectedOptions[btn.dataset.option] = btn.dataset.value;
    });

    function findVariant() {
      return variants.find(function(v) {
        return v.options.every(function(opt, i) {
          return selectedOptions[String(i + 1)] === opt;
        });
      });
    }

    function updateVariant(fromClick) {
      var variant = findVariant();
      var idInput = document.getElementById('fp-variant-id');
      var atcBtn = document.getElementById('fp-atc-btn');
      var priceEl = document.querySelector('.fp-price span:first-child');

      var buyBtnEl = document.getElementById('fp-buy-btn');
      var compareEl = document.querySelector('.fp-price .fp-price-compare');
      if (variant) {
        if (idInput && String(idInput.value) !== String(variant.id)) {
          idInput.value = variant.id;
          // Let Seal Subscriptions and other apps know the variant changed
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (atcBtn) { atcBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out'; atcBtn.disabled = !variant.available; }
        if (buyBtnEl) buyBtnEl.disabled = !variant.available;
        if (priceEl && variant.price) priceEl.textContent = '$' + (variant.price / 100).toFixed(2);
        if (compareEl) {
          var showCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
          compareEl.textContent = showCompare ? '$' + (variant.compare_at_price / 100).toFixed(2) : '';
          compareEl.style.display = showCompare ? '' : 'none';
        }
        if (fromClick && window.history && window.history.replaceState && variants.length > 1) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      } else if (fromClick && atcBtn) {
        // Only when a shopper picks a combination that doesn't exist
        atcBtn.textContent = 'Unavailable';
        atcBtn.disabled = true;
        if (buyBtnEl) buyBtnEl.disabled = true;
      }
    }

    document.querySelectorAll('.fp-variant-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var option = this.dataset.option;
        var value = this.dataset.value;

        // Update active state for this option group
        document.querySelectorAll('.fp-variant-btn[data-option="' + option + '"]').forEach(function(b) {
          b.classList.remove('active');
        });
        this.classList.add('active');

        selectedOptions[option] = value;
        updateVariant(true);
      });
    });

    // Initialize
    updateVariant();
  }
  document.querySelectorAll('.faq-question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = this.closest('.faq-item');
      var wasOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function(i) {
        i.classList.remove('open');
        var ic = i.querySelector('.faq-icon');
        if (ic) ic.textContent = '+';
      });
      if (!wasOpen) {
        item.classList.add('open');
        var ic = this.querySelector('.faq-icon');
        if (ic) ic.textContent = '−';
      }
    });
  });

  // ---- SCROLL REVEAL ----
  if ('IntersectionObserver' in window) {
    var style = document.createElement('style');
    style.textContent = '.reveal{opacity:0;transform:translateY(20px);transition:opacity 0.6s ease,transform 0.6s ease}.reveal.visible{opacity:1;transform:none}';
    document.head.appendChild(style);
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) { if (entry.isIntersecting) { entry.target.classList.add('visible'); obs.unobserve(entry.target); } });
    }, { threshold: 0.1 });
    document.querySelectorAll('.benefit-card, .why-card, .testimonial-card, .stat-item').forEach(function(el) {
      el.classList.add('reveal'); obs.observe(el);
    });
  }

});

// ---- CHECKOUT UPSELL ----
document.addEventListener('DOMContentLoaded', function() {
  var checkoutBtn = document.getElementById('checkout-btn');
  var modal = document.getElementById('upsell-modal');
  var overlay = document.getElementById('upsell-overlay');
  var yesBtn = document.getElementById('upsell-yes');
  var noBtn = document.getElementById('upsell-no');

  if (!checkoutBtn || !modal) return;

  function closeModal() {
    modal.style.display = 'none';
  }

  function goCheckout() {
    window.location.href = '/checkout';
  }

  checkoutBtn.addEventListener('click', function() {
    // Check if cart has Old Fashioned or Muscle Balm but NOT the combo
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      var ofId = yesBtn.dataset.ofId;
      var mbId = yesBtn.dataset.mbId;
      var comboId = yesBtn.dataset.comboId;

      var hasOf = cart.items.some(function(i) { return String(i.variant_id) === String(ofId) && i.quantity === 1; });
      var hasMb = cart.items.some(function(i) { return String(i.variant_id) === String(mbId) && i.quantity === 1; });
      var hasCombo = cart.items.some(function(i) { return String(i.variant_id) === String(comboId); });
      var hasSubscription = cart.items.some(function(i) { return i.selling_plan_allocation != null; });
      var hasMultiple = cart.items.some(function(i) {
        return (String(i.variant_id) === String(ofId) || String(i.variant_id) === String(mbId)) && i.quantity > 1;
      });

      // Show upsell only if they have exactly 1 OF or MB, not the combo, no subscriptions, and the Combo is in stock
      var comboAvailable = yesBtn.dataset.comboAvailable === 'true';
      if (comboAvailable && (hasOf || hasMb) && !hasCombo && !hasSubscription && !hasMultiple) {
        modal.style.display = 'flex';
      } else {
        goCheckout();
      }
    }).catch(function() { goCheckout(); });
  });

  if (overlay) overlay.addEventListener('click', closeModal);
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape' && modal.style.display !== 'none') closeModal(); });
  if (noBtn) noBtn.addEventListener('click', function() { closeModal(); goCheckout(); });

  if (yesBtn) yesBtn.addEventListener('click', function() {
    var comboId = this.dataset.comboId;
    var ofId = this.dataset.ofId;
    var mbId = this.dataset.mbId;
    if (!comboId) { goCheckout(); return; }

    yesBtn.textContent = 'Upgrading...';
    yesBtn.disabled = true;

    // Add The Combo FIRST. Only remove the single items once the Combo is safely in the cart,
    // so a failed add never leaves the customer at checkout with an empty cart.
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: comboId, quantity: 1 })
    })
    .then(function(r) {
      if (!r.ok) throw new Error('combo add failed');
      return fetch('/cart.js').then(function(r2) { return r2.json(); });
    })
    .then(function(cart) {
      var updates = {};
      cart.items.forEach(function(item) {
        var vid = String(item.variant_id);
        if (vid === String(ofId) || vid === String(mbId)) updates[item.key] = 0;
      });
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
    })
    .then(function() { goCheckout(); })
    .catch(function() { closeModal(); goCheckout(); });
  });
});
